module.exports = __webpack_public_path__ + "img/g966.3883f364.jpg";